import React, { useEffect, useState }  from 'react'

import { useConsultaSaldoPage } from 'hooks/useConsultaSaldoPage'
import { useArrayCard } from 'hooks/useArrayCard'

import ConsultarSaldoMobile from './Movil'
import ConsultarSaldoDesktop from './Desktop'

import { removeStorage } from 'functions/storageBase64'
import { ModalLoadingCredit } from 'components/Loading'
import useMooksConsulta from './ModulosConsulta/mocks'


export default function ConsultarSaldo() {

    // Mocks
    // const { validateCards, associatedCards, errorCode: errorCodeN, cardsService, setUdCard, errorCode: errorCodeT , isMobile } = useMooksConsulta()
    
    // Productivos
    const { validateCards, associatedCards, errorCode: errorCodeN , udCardsArray, setValidateCards} = useArrayCard();
    const {cardsService, setUdCard, errorCode: errorCodeT , isMobile } = useConsultaSaldoPage();

    const [ loading, setLoading ] = useState(true);

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        window.ineum('page', 'Check Balance Credit-Page');
        window.ineum('meta', 'portal', 'Credito');
        removeStorage('clickToPay')
    },[])

    useEffect(()=>{
        if(validateCards){
            setUdCard(true);
            //setLoading(false)
        }
    },[validateCards])

    const [load, setLoad] = useState(true);
    // const [load, setLoad] = useState();
    useEffect(()=>{
        setLoading(load);
    },[load])


    useEffect(()=>{
        setTimeout(function(){
            setLoading(false);
        }, 10000)
    },[])

    const [errorCode, setErrorCode ] = useState();
    useEffect(()=>{
        if(errorCodeT){
            setErrorCode(errorCodeT);
            setLoading(false);
        }else if(errorCodeN){
            setErrorCode(errorCodeN);
            setLoading(false);
        }
    },[errorCodeT, errorCodeN])

    removeStorage('pagoExpress');
    removeStorage('noInternetPayment');
    removeStorage('payCardRelation');
    removeStorage('payCodeSuccess');
    
    return (
        <>
            { loading && <ModalLoadingCredit /> }
            {isMobile
                ? isMobile === 'desktop'
                    ?
                        <ConsultarSaldoDesktop
                            cardsService={cardsService}
                            associatedCards={associatedCards}
                            setUdCard={setUdCard}
                            setLoad={setLoad}
                            errorCode={errorCode}
                        />
                    : 
                        <ConsultarSaldoMobile
                            cardsService={cardsService}
                            associatedCards={associatedCards}
                            setUdCard={setUdCard}
                            setLoad={setLoad}
                            errorCode={errorCode}
                        />
                : null
            }
        </>
    )
}